import React from "react";

const Typing = ({ username = "" }) => {
    return (
        <div className="typing-container">
            <span className="user--typing">{username} is typing</span>

            <div className="typing">
                <div className="typing--dot"></div>
                <div className="typing--dot"></div>
                <div className="typing--dot"></div>
            </div>
        </div>
    );
};

export default Typing;
